import React, { Component } from "react"

export default class StreetSymphonies extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Street Symphonies</p>
            <p className="portdesctext">Collection of posters that occasionally find themselves lining streets. Integrate my photography alongside my writing composed using PhotoShop and Illustrator. Dedicated venue in the works. Working on site.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href= 'https://www.dropbox.com/s/ouwe95ulqrzd8ti/allposters02012022.pdf?dl=0' target= "_blank" rel="noopener noreferrer"><p className="linktext">PDF</p></a>
        </div>
      </div>
  )
}
}

